<template>
  <v-container fluid>
    <new-appointment
      v-if="user.hasRoles(['reception'])"
      :patient="patient"
      :visibility.sync="newAppDialog"
      @saved="$router.push('/appointments')"
    />
    <v-layout row wrap align-center v-if="user.hasRoles(['reception'])">
      <v-flex xs12>
        <div class="section-title">Search Patient</div>
      </v-flex>
      <v-flex xs10>
        <async-autocomplete
          single-line
          label="Search by name"
          @change="setNewApp"
          v-model="patient"
          url="/api/patients/search"
          item-value="id"
          item-text="name"
          dense
          outline
          class="rounded"
          return-object
          hide-details
        ></async-autocomplete>
      </v-flex>

      <v-flex xs2>
        <v-btn color="primary" @click="$router.push('/patients?new=true')" icon>
          <v-icon>mdi-account-plus-outline</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>

    <v-layout row wrap v-if="user.hasRoles(['finance'])">
      <v-flex xs12>
        <div class="section-title">Quick Access</div>
        <div>
          <v-btn @click="$router.push('/payments')" large color="primary">
            Recieve Payment
            <v-icon right>mdi-receipt</v-icon>
          </v-btn>
          <v-btn @click="$router.push('/expenses?new=true')" large>
            Record Expense
            <v-icon right>mdi-cash</v-icon>
          </v-btn>
        </div>
      </v-flex>
    </v-layout>
    <v-layout row wrap v-if="user.hasRoles(['admin'])">
      <v-flex xs12>
        <div class="section-title">Today's Reports</div>
        <div>
          <v-btn @click="$router.push('/reports?type=summary')" large color="primary">Summary Report</v-btn>
          <v-btn @click="$router.push('/reports?type=appointments')" large>Appointments Report</v-btn>
          <v-btn @click="$router.push('/reports?type=payments')" large>Payments Report</v-btn>
          <v-btn @click="$router.push('/reports?type=expenses')" large>Expenses Report</v-btn>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import NewAppointment from "./appointments/new";
export default {
  middleware: ["auth", "appointment"],
  components: {
    NewAppointment
  },
  data: () => ({
    newAppDialog: false,
    patient: {}
  }),
  methods: {
    setNewApp() {
      this.newAppDialog = true;
    }
  },
  computed: {
    user() {
      return this.$store.getters["auth/user"];
    }
  }
};
</script>

<style>
</style>
